import _ from 'lodash';
import URI from 'urijs';
import { getConfig } from './config';

export default (path, sectionUrl) => {
  const url = new URI(sectionUrl || getConfig().sectionUrl || '');
  url.pathname(_.trimEnd(url.pathname(), '/') + path);
  return url.toString();
};



// WEBPACK FOOTER //
// ./app/services/get-outer-url.js